import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'

import { bookerProgression, bookingStages } from '@/lib/stores/booker-store'
import { RootStoreContext } from '@/lib/stores/root-store'
import { cn } from '@/lib/utils'

export const BookerNavIndicator = observer(() => {
  const {
    bookerStore: { stage, paymentCollectionType },
  } = useContext(RootStoreContext)

  return (
    <div className="flex w-full shrink flex-row items-center justify-center">
      {bookingStages
        .filter((bookingStage) => {
          const logic = bookerProgression[bookingStage]
          return !(logic.skip && logic.skip({ paymentCollectionType }))
        })
        .map((bookingStage, index) => (
          <div
            key={bookingStage}
            className={cn('mr-2 rounded-full', {
              'h-4 w-8 bg-primary opacity-70':
                stage === bookingStage || (stage === null && index === 0),
              'size-4 bg-muted':
                stage !== bookingStage && (stage !== null || index !== 0),
            })}
          />
        ))}
    </div>
  )
})
